import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource } from 'react-dnd';
import { store, ComponentDesc, ShelfComponentProps, ScreenComponentProps, SettingsComponentProps, getDefaultSettings } from '../store';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BackgroundColorPicker from './common/BackgroundColorPicker';

import { shelfComponentStyles, settingsComponentStyles } from './common/styles';
import withStyles from 'react-jss';
import { SketchPicker } from 'react-color';

const social_media = require('./icons/social_media.svg');
const twitter_icon = require('./icons/twitter.svg');
const fb_icon = require('./icons/facebook.svg');
const instagram_icon = require('./icons/instagram.svg');
const linked_icon = require('./icons/linkedin.svg');
//const menu_button = require('./icons/menu_button.svg');

interface ImageSettings {
    fb: string;
    twitter: string;
    instagram: string;
    linkedin: string;
    src: string;
}

let defaultTemplate = {
    type: 'SOCIALICONS',
    style: {
        ...getDefaultSettings(),
        backgroundColor: '#f3f2f9',
    },
    settings: {
        src: 'https://via.placeholder.com/125x125',
        fb: 'https://www.facebook.com',
        twitter: 'https://www.twitter.com',
        instagram: 'https://www.instagram.com',
        linkedin: 'https://www.linkedin.com',
    },
    name: 'Social Icons',
};

const draggableShelfComponent = flowRight([
    withStyles(shelfComponentStyles),

    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props: any): ComponentDesc<ImageSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        function collect(connect, monitor) {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
    observer,
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={social_media} className={classes.icon} />
                <span className={classes.label} style={{ marginLeft: 'unset' }}>
                    Social Icons
                </span>
                {/*<img src={menu_button} style={{ marginLeft: -9 }} />*/}
            </div>
        </div>
    );
});

const draggableScreenComponent = flowRight([observer])((props: ScreenComponentProps<ImageSettings>) => {
    let { descriptor } = props;
    return (
        <div
            style={{
                cursor: 'move',
                minHeight: '10px',

                ...descriptor.style,
            }}
            onClick={(e) => store.selectComponent(descriptor)}>
            <div
                // style={{ display: 'flex', flexBasis: 'row' }}
                style={{ alignItems: 'center' }}
                className=" socialMediaUrl">
                <a href={descriptor.settings.fb ? descriptor.settings.fb : ''}>{descriptor.settings.fb ? <img src={fb_icon} height="40px" width="40px" style={{ margin: 10 }} /> : null}</a>

                <a href={descriptor.settings.twitter ? descriptor.settings.twitter : ''}>{descriptor.settings.twitter ? <img src={twitter_icon} height="40px" width="40px" style={{ margin: 10 }} /> : null}</a>
                <a href={descriptor.settings.instagram ? descriptor.settings.instagram : ''}>{descriptor.settings.instagram ? <img src={instagram_icon} height="40px" width="40px" style={{ margin: 10 }} /> : null}</a>
                <a href={descriptor.settings.linkedin ? descriptor.settings.linkedin : ''}>{descriptor.settings.linkedin ? <img className=" linkedIcon" src={linked_icon} height="40px" width="40px" style={{ margin: 10 }} /> : null}</a>
            </div>
        </div>
    );
});

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(function({ descriptor, classes }: SettingsComponentProps<ImageSettings, typeof settingsComponentStyles>) {
    return (
        <div>
            <div className={classes.root} style={{ paddingBottom: 10 }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            paddingTop: 10,
                        }}>
                        <span className={classes.header} style={{ width: 74 }}>
                            Facebook
                        </span>
                        <input type="text" value={descriptor.settings.fb} onChange={(e) => (descriptor.settings.fb = e.target.value)} className={classes.socialsrc} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingTop: 10,
                        }}>
                        <span className={classes.header} style={{ width: 74 }}>
                            {' '}
                            Twitter
                        </span>
                        <input type="text" value={descriptor.settings.twitter} onChange={(e) => (descriptor.settings.twitter = e.target.value)} className={classes.socialsrc} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingTop: 10,
                        }}>
                        <span className={classes.header} style={{ width: 74 }}>
                            LinkedIn
                        </span>
                        <input type="text" value={descriptor.settings.linkedin} onChange={(e) => (descriptor.settings.linkedin = e.target.value)} className={classes.socialsrc + ' linkedUrl'} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingTop: 10,
                        }}>
                        <span className={classes.header} style={{ width: 74 }}>
                            Instagram
                        </span>
                        <input type="text" value={descriptor.settings.instagram} onChange={(e) => (descriptor.settings.instagram = e.target.value)} className={classes.socialsrc} />
                    </div>
                </div>
            </div>
            <div>
                <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'SOCIALICONS',
    type: 'component',
    shelfComponent: draggableShelfComponent,
    screenComponent: draggableScreenComponent,
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg: social_media,
});

//export default withStyles(styles)(observer(component))
